import { render, staticRenderFns } from "./PurInBillList.vue?vue&type=template&id=2e454ca2&scoped=true&"
import script from "./PurInBillList.vue?vue&type=script&lang=js&"
export * from "./PurInBillList.vue?vue&type=script&lang=js&"
import style0 from "./PurInBillList.vue?vue&type=style&index=0&id=2e454ca2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e454ca2",
  null
  
)

export default component.exports